import React, { useState } from "react";
import styles from "./Assessment.module.css";
import { Controller, useForm } from "react-hook-form";
import { hooks } from "../../studentportal-sdk";

const QuizCreator = (props) => {
  const [quizTitle, setQuizTitle] = useState("");
  const [quizDescription, setQuizDescription] = useState("");
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [options, setOptions] = useState([
    { text: "", score: 0 },
    { text: "", score: 0 },
    { text: "", score: 0 },
    { text: "", score: 0 },
  ]);
  const [correctOption, setCorrectOption] = useState(0);

  const addQuestion = () => {
    if (
      currentQuestion.trim() === "" ||
      options.some((opt) => opt.text.trim() === "")
    ) {
      alert("Please fill in all fields for the question.");
      return;
    }

    const newQuestion = {
      question: currentQuestion,
      options: [...options],
      correctOption,
    };

    setQuestions([...questions, newQuestion]);
    setCurrentQuestion("");
    setOptions([
      { text: "", score: 0 },
      { text: "", score: 0 },
      { text: "", score: 0 },
      { text: "", score: 0 },
    ]);
    setCorrectOption(0);
  };

  const createQuiz = () => {
    // if (quizTitle.trim() === "" || questions.length === 0) {
    //   alert("Please provide a quiz title and add at least one question.");
    //   return;
    // }

    const newQuiz = {
      userId: "user_id_here", // Replace with actual user ID
      assessmentId: "assessment_id_here", // Replace with actual assessment ID
      title: quizTitle,
      description: quizDescription,
      questions: questions.map((q) => ({
        text: q.question,
        type: "option", // Assuming "option" type for all
        options: q.options.map((opt) => ({
          text: opt.text,
          score: Number(opt.score), // Ensure score is a number
        })),
      })),
    };

    // addAssessment(newQuiz); // API call to send the quiz
    setQuizTitle("");
    setQuizDescription("");
    setQuestions([]);
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {},
  });

  const {
    assessmentService: {
      store: { loading, assessmentDocs },
      action: { addAssessment, createQuestion },
    },
  } = props;

  const handleOptionChange = (index, field, value) => {
    const newOptions = [...options];
    newOptions[index] = { ...newOptions[index], [field]: value };
    setOptions(newOptions);
  };

  const onSubmit = (data) => {
    const question = {...data, options}
    createQuestion(question)
  };

  return (
    <div>
      <h2>Create a New Quiz</h2>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.formGroup}>
          <label>Select Assessment:</label>
          <Controller
            name="assesmentId"
            control={control}
            render={({ field: { value, onChange } }) => (
              <select
                className={`form-control ${
                  errors?.assesmentId ? "error-input" : ""
                }`}
                name="assesmentId"
                value={value}
                onChange={onChange}
              >
                <option value="">Select Assessment</option>
                {assessmentDocs &&
                  assessmentDocs.map((assessment) => (
                    <option key={assessment.id} value={assessment.id}>
                      {assessment.title}
                    </option>
                  ))}
              </select>
            )}
            defaultValue=""
          />
          <small className="text-danger">{errors?.assesmentId?.message}</small>
        </div>

        <h3>Add Questions</h3>
        <div className={styles.formGroup}>
          <label>Question:</label>
          <Controller
            name="text"
            control={control}
            render={({ field: { value, onChange } }) => (
              <input
                type="text"
                value={value}
                onChange={onChange}
                className={`form-control ${errors?.title ? "error-input" : ""}`}
                placeholder="Enter question"
              />
            )}
            defaultValue=""
          />

          <small className="text-danger">{errors?.text?.message}</small>
        </div>
        <div className={styles.formGroup}>
          <label>Type:</label>
          <Controller
            name="type"
            control={control}
            render={({ field: { value, onChange } }) => (
              <>
                <select
                  className={`form-control ${
                    errors?.type ? "error-input" : ""
                  }`}
                  name="type"
                  type="text"
                  value={value}
                  onChange={onChange}
                >
                  <option className="form-control" value="">
                    Select Category
                  </option>
                  <option className="form-control" value="option">
                    Option
                  </option>
                  <option className="form-control" value="multi-option">
                    Multi-Option
                  </option>
                </select>
              </>
            )}
            defaultValue=""
          />
          <small className="text-danger">{errors?.type?.message}</small>
        </div>

        <div className={styles.formGroup}>
          <label>Options:</label>
          {options.map((opt, idx) => (
            <div key={idx} className="row">
              <div className="col-md-4">
                <input
                  type="text"
                  value={opt.text || ""}
                  onChange={(e) =>
                    handleOptionChange(idx, "text", e.target.value)
                  }
                  className="form-control"
                  placeholder={`Option ${idx + 1}`}
                />
              </div>
              <div className="col-md-4">
                <input
                  type="number"
                  value={opt.score }
                  onChange={(e) =>
                    handleOptionChange(idx, "score", e.target.value)
                  }
                  className="form-control"
                  placeholder="Score"
                />
              </div>
            </div>
          ))}
        </div>

        {/* <button onClick={addQuestion} className={styles.addButton}>
        Add Question
      </button> */}

        <button onClick={createQuiz} className={styles.submitButton}>
          Create Quiz
        </button>
      </form>
    </div>
  );
};

export default (props) => <QuizCreator {...hooks.assessment(props)} />;
